import TheGrid from '@/views/familymembertypes/grid'
import Edit from '@/views/familymembertypes/edit'
import TheView from '@/views/familymembertypes/view'

export default {
  path: '/familymembertypes',
  redirect: '/familymembertypes/index',
  name: 'familymembertypes',
  meta: {
    auth: {
      redirect: {
        name: 'familymembertypes.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Escalões'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'familymembertypes.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'familymembertypes.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'familymembertypes.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'familymembertypes.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
